export const style = {
  action: {
    grid: {
      sx: { m: -1 },
    },
    create: {
      icon: {
        fontSize: 'small',
      },
      variant: 'contained',
      sx: {
        m: 1,
        backgroundColor: 'secondary.main',
      },
    },
    edit: {
      icon: {
        fontSize: 'small',
      },
      variant: 'outlined',
    },
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    flexDirection: 'column',
    flex: 1,
  },
  mainContainer: {
    mt: 2,
    columns: 12,
    spacing: 2,
  },
  btn: {
    variant: 'contained',
    sx: {
      backgroundColor: 'secondary.main',
    },
    size: 'medium',
  },
  typography: {
    variant: 'h4',
    marginBottom: '10px',
  },
  creationStamp: {
    display: 'flex',
    alignItems: 'center',
    color: 'primary.text',
  },
  talentInfo: {
    color: 'text.secondary',
    blockInfo: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      marginTop: '5px',
    },
    talentTitle: {
      typography: {
        variant: 'h4',
      },
    },
    createInfo: {
      maxWidth: '270px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    updateInfo: {
      maxWidth: '270px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginLeft: '8px',
    },
  },
  header: {
    style: {
      zIndex: 5,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '8px',
    },
    sx: {
      backgroundColor: 'background.default',
      maxWidth: 1100,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
  },
  avatar: {
    width: 64,
    height: 64,
    p: 0,
    backgroundColor: '#6B7280',
    emptyStateIcon: {
      borderRadius: '50%',
      sx: {
        bgColor: 'primary.main',
      },
    },
    fontSize: 25,
    badge: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    },
  },
  btns: {
    container: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'flex-end',
      gap: 1,
    },
    draftButton: {
      m: 1,
      '&:disabled': {
        opacity: '0.34',
        backgroundColor: 'primary.main',
        color: 'primary.contrast',
      },
    },
    boxTrash: {
      color: 'action',
      sx: {
        width: 25,
        pX: 2,
        '&: hover': {
          cursor: 'pointer',
        },
      },
    },
    containsBtn: {
      buttonSize: 'medium',
      buttonVariantContained: 'contained',
      buttonVariantOutlined: {
        vaiant: 'outlined',
      },
      backgroundColor: 'secondary.main',
      m: 1,
    },
    buttonPublished: {
      maxWidth: 120,
      backgroundColor: 'secondary.states.hoverBackground',
      m: 1,
      color: 'secondary.states.hoverBackgroundContained',
      ':hover': {
        backgroundColor: 'primary.states.hoverBackground',
        color: 'primary.states.hoverContained',
      },
    },
  },
  clipboard: {
    '&:hover svg': {
      display: 'block',
    },
    '&:not(:hover) svg': {
      display: 'none',
    },
  },
} as const;
